import { API } from '@Providers';

// TODO - AF-545 Missing interface
export default async function (payload: any) {
  const endpoint = '/api/shelter/cart/complete-outcome';

  localStorage.removeItem('cart-uploaded-files');
  localStorage.removeItem('cart-files-ids');

  return API({ endpoint, method: 'post', payload });
}
